import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setUserDetails } from "../Utility/AsyncStorage"
import axios from "axios";
import { showToast } from './Toast';

import "../Styles/Login.css";
import MyImage from "../Assets/logo.png";


const Login = (e) => {

    const navigate = useNavigate();
    const [formData, setFormData] = useState({ username: "", password: "" });

    const handleLogin = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        console.log("handleSubmit")
        try {
            if (formData.username === "") {
                console.log("Enter email / phone no.")
                showToast("Provide Login Details first", 3000, "red");
                return
            }
            let url = process.env.REACT_APP_BASE_URL + "/api/userLogin1";
            let body = {
                email: formData.username,
                password: "1234"
            }
            console.log("body login", body)
            await axios.post(url, body, {
                // headers: {
                //   'authorization': `${userDetails.access_token}`
                // },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        console.log("statsData", response.data.result)
                        setUserDetails(JSON.stringify(response.data.result));
                        if (response.data.result.comp_num === 260) {
                            navigate("/dashboard", { state: { statsData: response.data.result } })
                        }
                        else {

                            showToast("User not Resistor", 3000, "red");
                            console.log("User not Resistor")
                        }
                    }
                    else {
                        console.log("statsData", response.data.msg)
                    }

                }
                
                else if (response.status === 403) {
                    handleSubmit()
                }
                else{
                    showToast(response.data.msg, 3000, "red");
                }

            }).catch(error => {
                console.log("statsData", error)
            })
        } catch (error) {
            console.log("statsData", error)
        }
        // navigate("/dashboard");

    }
    return (
        <div className="login-wrapper">
            <div className="login-container">
                <div className="right-section">
                    <div className="form-container">

                        <img src={MyImage} alt="A descriptive text" style={{ width: "150px", height: "auto" }} />
                        <h2>Welcome to IFFOverseas</h2>
                        <p>Sign in to continue</p>
                        <div>
                            <div>
                                <label className="label">Email / Phone no.</label>
                                <input type="text"
                                    name="username"
                                    placeholder="Username"
                                    value={formData.username}
                                    onChange={handleLogin}
                                    className="form-input"
                                    required
                                />
                            </div>
                            {/* <div>
                                <label className="label">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleLogin}
                                    className="form-input"
                                    required
                                />
                            </div> */}
                            <button type="submit" className="login-button" onClick={() => handleSubmit()}>
                                Login
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
